import { createSelector } from 'reselect';
import { data as dataSelector, data2 as data2Selector } from '../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from './PersonalInfoWorkflowConstants';

export const principalFirstName = createSelector(dataSelector, data =>
  data(`${BACKEND_KEY}.Principal.FirstName`));
export const principalAge = createSelector(dataSelector, data =>
  data(`${BACKEND_KEY}.Principal.Age`));

export const partnerFirstName = createSelector(dataSelector, data =>
  data(`${BACKEND_KEY}.Partner.FirstName`));
export const partnerAge = createSelector(dataSelector, data => data(`${BACKEND_KEY}.Partner.Age`));

export const hasPermanentPartnerData = createSelector(dataSelector, (data) => {
  const ageKey = `${BACKEND_KEY}.Partner.Age`;
  const nameKey = `${BACKEND_KEY}.Partner.FirstName`;

  const age = data(ageKey) || '';
  const name = data(nameKey) || '';

  return name.length > 0 && parseInt(age, 10) > 0;
});

export const personalInfoSelector = createSelector(dataSelector, data => data(`${BACKEND_KEY}`));

export const hasSelectedIsMarried = createSelector(data2Selector, data => data(`${BACKEND_KEY}.HasPartner`));
